import styled from 'foundations-theming-specialty/utils';
import { getAgentInitials } from '../../../utils/agentUtils';
import * as BreezeColors from '../../../styles/colors';
// --- AgentInitialsIcon Component ---
import { jsx as _jsx } from "react/jsx-runtime";
const StyledInitialsFlex = styled.div.withConfig({
  displayName: "AgentInitialsIcon__StyledInitialsFlex"
})(["display:flex;align-items:center;justify-content:center;border-radius:", ";background-color:", ";block-size:", ";inline-size:", ";margin-block-end:", ";min-block-size:", ";min-inline-size:", ";position:relative;"], ({
  theme,
  background,
  borderRadius
}) => {
  if (background !== 'gradient') {
    return theme.borderRadius['0'];
  }
  return borderRadius != null ? `${borderRadius}px` : theme.borderRadius['300'];
}, props => props.background === 'gradient' ? props.theme.color['fill-accent-orange-subtle-alt'] : 'transparent', props => props.background === 'gradient' ? props.size : 'auto', props => props.size, ({
  theme,
  marginBlockEnd
}) => {
  const spaceKey = marginBlockEnd || '400';
  return theme.space[spaceKey];
}, props => props.background === 'gradient' ? props.size : props.theme.typography['body-125'].fontSize, props => props.size);
const StyledInitialsText = styled.span.withConfig({
  displayName: "AgentInitialsIcon__StyledInitialsText"
})(["position:relative;background:", ";background-clip:text;color:transparent;font-weight:", ";font-size:", ";margin:", ";line-height:1;"], BreezeColors.GRADIENT.AGENT_ICON, ({
  theme
}) => theme.typography['heading-300'].fontWeight, props => props.size, ({
  theme
}) => theme.space['0']);
export const AgentInitialsIcon = ({
  agentName,
  marginBlockEnd,
  size,
  borderRadius,
  background = 'gradient'
}) => {
  const initials = getAgentInitials(agentName);
  const numericalSize = size || 48;
  const containerSize = `${numericalSize}px`;
  const textSize = `${numericalSize / 2 - 1}px`;
  return /*#__PURE__*/_jsx(StyledInitialsFlex, {
    borderRadius: borderRadius,
    size: containerSize,
    marginBlockEnd: marginBlockEnd,
    background: background,
    "data-test-id": "agent-initials-icon",
    children: /*#__PURE__*/_jsx(StyledInitialsText, {
      size: textSize,
      children: initials
    })
  });
};